import { axios } from '@playbookux/playbook-web-core';
import { config } from '../../config';

const { REACT_APP_BROWSER_EXTENSION_VERSION_URI } = config;

const versionCheck = () => axios.get(REACT_APP_BROWSER_EXTENSION_VERSION_URI, {
  headers: {
    'Cache-Control': 'no-cache',
  },
});

export default versionCheck;
